<template>
  <div class="page">
    <!-- <div class="right">
        <a class="to-rank" href="rank.html">投票排行榜</a>
      </div> -->
    <Waterfall :listData="works" :status="isMyworks" @useGetData="getData" />
    <WorksGroup @getGid="filterData" v-if="works.length > 0" />
    <div class="empty" v-if="total == 0">
      <i></i>
      <p>抱歉！没有找到相关投稿内容。</p>
    </div>
  </div>
</template>

<script>
import Waterfall from "@/components/Waterfall";
import WorksGroup from "@/components/WorksGroup";
// import tools from "@/utils/common";
export default {
  components: {
    Waterfall,
    WorksGroup,
  },
  // props: {
  //   worksGroup: {
  //     type: Array,
  //   },
  // },
  data() {
    return {
      id: this.$route.params.id,
      works: [],
      // 是否到底部
      end: false,
      gid: "",
      page: 1,
      totalPages: 2,
      pagesize: 20, // 默认每页20条数据
      total: 1,
      isShowGroup: false,
      data: [],
      isMyworks: true,
    };
  },
  methods: {
    filterWoks(gid) {
      if (this.gid != gid) {
        this.$router.push({ query: { group: gid } });
      }
      this.gid = gid;
      this.page = 1;
      this.end = false;
      this.works = [];
      // 重新筛选
      this.getData();
    },
    getList(res) {
      this.works = this.works.concat(res);
      if (this.page < this.totalPages) {
        this.page++;
      } else {
        this.end = true;
      }
    },
    getData() {
      // console.log(this.end);
      if (this.end) {
        return false;
      }
      // console.log(this.gid);
      this.axios
        .post("/match/myworks?group=" + this.gid, {
          id: this.id,
          page: this.page,
          pagesize: this.pagesize,
        })
        .then((res) => {
          var data = res.data.data;
          if (this.page <= 1) {
            this.total = data.total;
            this.totalPages = data.totalPages;
          }
          this.getList(data.list);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterData(gid) {
      this.filterWoks(gid);
    },
  },
  mounted() {
    // if (!this.$store.state.isLogin) {
    //   /* eslint-disable */
    //   // 调用passport
    //   passportLogin.login();
    //   /* eslint-enable */
    // }
    //this.cur = this.$route.query.index;
    this.gid = this.$route.query.group;
    if (this.gid == undefined) {
      this.gid = "";
    }
    // this.filterWoks(this.gid);
  },
};
</script>

<style></style>
